import React, { PropTypes, Component } from 'react';
import styled from 'styled-components';
import classnames from 'classnames';

import { media } from 'style-utils';

import { NitroIcon } from 'nitro-components';

const Td = styled.td`
  position: relative;

  &:last-of-type {
    padding-left: 50px;
    padding-right: 50px;
  }
`;

const TableBody = styled.tbody``;

const Heading = styled.tr`
  cursor: pointer;
  background-color: #F8F9F8;

  ${Td} {
    &:first-child {
      width: 60%;

      ${media.mobileTablet`
        width: 40%;
      `}
    }
  }
`;

const Content = styled.tr`
  background-color: ${props => props.theme.color.white} !important;
  padding: 0;
  height: ${props => props.active ? 'auto' : 0};

  ${Td} {
    &:first-child {
      color: initial;
      font-family: ${props => props.theme.font.default};
      padding-left: 40px;
    }
  }

  &:nth-child(2) {
    ${Td} {
      font-family: ${props => props.theme.font.bold} !important;
    }
  }
`;

const AccorionIcon = styled.div`
  position: absolute;
  top: 18px;
  right: 18px;
`;

class InsightTableAccordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: !!this.props.active
    };
  }

  open = () => {
    this.setState({
      active: true
    });
  }

  close = () => {
    this.setState({
      active: false
    });
  }

  toggle = () => {
    this.setState({
      active: !this.state.active
    });
  }

  renderChildrenRows() {
    if (!this.state.active) {
      return null;
    }

    // Add model row before children
    const modelRow = [this.props.categorySubName, '', ''];

    return [modelRow, ...this.props.content].map((child, index) => (
      <Content key={`child-${index}`}>
        {child.map((item, i) => (
          <Td className="table-data-align-center" key={`${item}-${index}-${i}`}>{item}</Td>
        ))}
      </Content>
    ));
  }

  render() {
    const { className, header, categorySubName } = this.props;

    const direction = this.state.active ? 'up' : 'down';
    const classes = classnames('accordion', className);

    return (
      <TableBody className={classes}>
        <Heading onClick={this.toggle}>
          {header && header.map((item, index) => (
            <Td className="table-data-align-center" key={`${item}-${index}`}>
              {item}
              {index === (header.length - 1) && (
                <AccorionIcon>
                  <NitroIcon name={`accordion-${direction}`} size={12} />
                </AccorionIcon>
              )}
            </Td>
          ))}
        </Heading>
        {this.renderChildrenRows()}
      </TableBody>
    );
  }
}

InsightTableAccordion.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  content: PropTypes.array,
  header: PropTypes.array,
  categorySubName: PropTypes.string,
};

export default InsightTableAccordion;



// WEBPACK FOOTER //
// ./src/features/insights/components/InsightTableAccordion.js